
          import "Secondary_5xc411.linaria.css";
          import { focusStyle } from "@carvana/showroom-css-theme";
import { styled } from "@linaria/react";
import Button from "./Base";
export default /*#__PURE__*/styled(Button)({
  name: "Secondary0",
  class: "sdqfaaq"
});
          